export const hasValue = (asyncState)=>asyncState.kind == 'loaded' || asyncState.kind == 'loading' && !!asyncState.value;
export const previousOrDefault = (asyncState, defaultValue)=>hasValue(asyncState) ? asyncState.value : defaultValue;
export const previousOrNull = (asyncState)=>hasValue(asyncState) ? asyncState.value : null;
